import React from 'react'
import PropTypes from 'prop-types'
import LibrarySkeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

/**
 * A loading placeholder in the shape of the content that is on its way.
 *
 *   {loading ? <Skeleton height={48} count={3} /> : rows}
 *
 * A thin wrapper over `react-loading-skeleton`, which the app already ships, rather than a second
 * implementation. What the wrapper adds:
 *
 * - One import, here, for the library's stylesheet, instead of one per screen.
 * - Colours from the neutral ramp instead of the library's `#ebebeb` / `#f5f5f5`, so placeholders
 *   sit on the same warm greys as the surfaces around them. Both are still overridable, by prop
 *   here or for a subtree with the library's `SkeletonTheme`.
 *
 * Reduced motion needs nothing extra: the library's own stylesheet turns the shimmer off under
 * `prefers-reduced-motion`, leaving a still block. Assistive tech hears it as busy (the library
 * marks its wrapper `aria-busy` and `aria-live="polite"`), so do not add a second loading
 * announcement next to one; announce the region as a whole if it needs announcing.
 *
 * Every other prop goes straight to the library: `width`, `height`, `count`, `circle`, `inline`,
 * `borderRadius`, `wrapper`, `className`, `containerClassName`, `enableAnimation`.
 */
const Skeleton = ({ baseColor = 'var(--neutral-200)', highlightColor = 'var(--neutral-100)', ...rest }) => (
  <LibrarySkeleton baseColor={baseColor} highlightColor={highlightColor} {...rest} />
)

Skeleton.propTypes = {
  baseColor: PropTypes.string,
  highlightColor: PropTypes.string,
}

export default Skeleton
